"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.submissionSchema = void 0;
var constants_1 = require("@hobt/constants");
var contact_schema_1 = require("./contact-schema");
exports.submissionSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['contact', 'reportingPeriod', 'reportingPeriodID'],
    properties: {
        submissionID: {
            type: ['string', 'null'],
            format: 'uuid',
            errorMessage: 'Should follow UUID format 00000000-0000-0000-0000-000000000000 or null',
        },
        contact: contact_schema_1.contactSchema,
        locationName: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 50,
            errorMessage: 'Should be a string with a maximum of 50 characters or null',
        },
        recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordCreatedUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        },
        recordUpdatedUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        remarkText: {
            type: ['string', 'null'],
            minLength: 0,
            maxLength: 150,
            errorMessage: 'Should be a string with a maximum of 150 characters or null',
        },
        reportingPeriod: {
            type: 'string',
            minLength: 1,
            maxLength: 10,
            errorMessage: 'Should be a string with a maximum of 10 characters',
        },
        reportingPeriodID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
        statusCode: {
            type: 'number',
            enum: Object.values(constants_1.SubmissionStatus),
            errorMessage: 'Should equate to a valid SubmissionStatus Enum value',
        },
    },
};
